export default __webpack_public_path__ + "static/media/userborder.949513b5.svg";